"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functions = require("../utils/functions");

var _constants = require("../utils/constants");

var _default = function _default() {
  var existLS = function existLS(item) {
    var _window = window,
        localStorage = _window.localStorage;
    return !!localStorage && typeof localStorage !== 'undefined' && localStorage.getItem(item);
  };

  var newRept = existLS('userid_datalayer') ? _constants.REPEAT : _constants.NEW;
  var newDate = new Date();
  var visitDate = newDate.toISOString();
  return {
    newRept: newRept,
    userId: (0, _functions.assignUserId)(),
    visitDate: visitDate,
    OS: (0, _functions.getOS)(),
    adblockActived: undefined
  };
};

exports["default"] = _default;